import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { Course }           from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    filters   : {
        search   : "",
        status   : "",
        fromDate : "",
        toDate   : "",
    },
    sort       : {
        orderBy  : "availableFromTime",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "COURSE_LOADING" });
    },

    /**
     * Fetches the Course List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, filters = {}, sort = {}) {
        const params = { ...filters, ...sort };
        Navigate.unsetParams(params);
        if (type === "ACTIVITY") {
            params.activityID = elemID;
        }

        const data   = await Course.getAll(params);
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "COURSE_LIST", data });
    },

    /**
     * Fetches a single Course
     * @param {Function} dispatch
     * @param {Number}   courseID
     * @returns {Promise}
     */
    async fetchElem(dispatch, courseID) {
        const data = await Course.getOne({ courseID });
        dispatch({ type : "COURSE_ELEM", data });
    },

    /**
     * Fetches the Course Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Course.getEditData();
        dispatch({ type : "COURSE_EDIT", data });
    },

    /**
     * Edits/Creates a Course
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Course.edit(data);
    },

    /**
     * Confirms a Course
     * @param {Function} dispatch
     * @param {Number}   courseID
     * @returns {Promise}
     */
    confirmElem(dispatch, courseID) {
        return Course.confirm({ courseID });
    },

    /**
     * Deletes a Course
     * @param {Function} dispatch
     * @param {Number}   courseID
     * @returns {Promise}
     */
    deleteElem(dispatch, courseID) {
        return Course.delete({ courseID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.availableFromDateTime = DateTime.formatDate(elem.availableFromTime, "dashesTime");
    elem.availableFromDate     = DateTime.formatDate(elem.availableFromTime, "dashesReverse");
    elem.availableFromHour     = DateTime.formatDate(elem.availableFromTime, "time");
    elem.availableToDateTime   = DateTime.formatDate(elem.availableToTime, "dashesTime");
    elem.availableToDate       = DateTime.formatDate(elem.availableToTime, "dashesReverse");
    elem.availableToHour       = DateTime.formatDate(elem.availableToTime, "time");
    elem.fromDateTime          = DateTime.formatDate(elem.fromTime, "dashes");
    elem.fromDate              = DateTime.formatDate(elem.fromTime, "dashesReverse");
    elem.toDateTime            = DateTime.formatDate(elem.toTime, "dashes");
    elem.toDate                = DateTime.formatDate(elem.toTime, "dashesReverse");

    elem.questionsList         = elem.questions.map((item) => item.question);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "COURSE_LIST", "COURSE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "COURSE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "COURSE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            statuses  : action.data.statuses,
            filters   : action.data.filters,
            sort      : action.data.sort,
        };

    case "COURSE_ELEM":
        return {
            ...state,
            error     : false,
            canEdit   : action.data.canEdit,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            statuses  : action.data.statuses,
        };

    case "COURSE_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
